<app-topbar></app-topbar>
<div class="layout-content">
	<ui-view name="rootContent"></ui-view>
</div>
